import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { PaymentTokenAction } from '../controller/actions';
import { Grid, Header, Loader, Button } from 'semantic-ui-react';

export default function WindcaveProcessPage() {
    const dispatch = useDispatch();
    const query = useQuery();
    const paymentToken = useSelector((state) => state.paymentToken);
    const [invalidParams, setInvalidParams] = useState(false);

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const processPayment = () => {
        const region = query.get('Region') ? query.get('Region') : 'AU';
        const result = query.get('result') ? query.get('result') : null;
        const userid = query.get('userid') ? query.get('userid') : null;
        if (result && userid){
            const requestBody = {
                region: region,
                result: result,
                userid: userid,
                produceMessage: paymentToken.produceMessage,
                successRedirectUrl: paymentToken.successRedirectUrl,
            };
            dispatch(new PaymentTokenAction().windcaveProcessPayment(requestBody));
        } else {
            setInvalidParams(true);
        }
    };

    const returnBackToPaymentPortal = () => {
        if (paymentToken?.successRedirectUrl) {
            window.location.assign(`${paymentToken?.successRedirectUrl}?payment_details_updated=false`);
        }
    };

    useEffect(() => {
        processPayment();
        // eslint-disable-next-line
    }, []);

    return (
        <Grid verticalAlign="middle" centered style={{'padding': '120px'}}>
            <Grid.Row>
                {
                    invalidParams === false && (paymentToken && paymentToken.loader) && 
                    <Header size="large">Processing <Loader active inline /></Header>
                }
                {
                    paymentToken && paymentToken.failed === true &&
                    <Header size="large">
                        Process failed <br/><br/>
                        <Button onClick={processPayment} basic color="black" content="Retry"/>
                        {paymentToken?.successRedirectUrl?.length > 0 && 
                            <Button onClick={returnBackToPaymentPortal} basic color="grey" content="Cancel"/>    
                        }
                    </Header>
                }
                {
                    invalidParams === true &&
                    <Header size="large">404 - Page not found</Header>
                }
            </Grid.Row>
        </Grid>
    );
}